export default __webpack_public_path__ + "static/media/celular-suvinil.8e09da09.png";